// extracted by mini-css-extract-plugin
export default {"controlTitleContainer":"ProductControl_controlTitleContainer__0RUfI","controlTitle":"ProductControl_controlTitle__EJuAi"};